import { action } from 'mobx';
import { ProcedureCodeUploadForm } from 'application/procedure-code/forms';
import { BaseEditViewStore } from 'core/stores';
import {applicationContext} from 'core/utils';
import {ProcedureCodeService} from 'application/product/services';

@applicationContext
class ProcedureCodeUploadViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const procedureCodeService = new ProcedureCodeService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'file',
            Form: ProcedureCodeUploadForm,
            actions: () => {
                return {
                    create: async () => {
                        var file = this.form.fields.get("file").files[0];
                        await procedureCodeService.upload({file: file});
                    }
                }
            },
            FormClass: ProcedureCodeUploadForm,
        });
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success('PROCEDURE_CODE.UPLOAD.SUCCESS'), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(err && err.data && err.data.Message ? err.data.Message : 'PROCEDURE_CODE.UPLOAD.ERROR');
        }
    }

    @action.bound
    async onInit({ initialLoad }) {
        if(!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }
}

export default ProcedureCodeUploadViewStore;
